import {
	Box,
} from 'native-base';
import { WebView } from 'react-native-webview'; // https://github.com/react-native-community/react-native-webview/blob/master/docs/Reference.md
import onMessage from '../OneHat/functions/onMessage';
import AppGlobals from '../AppGlobals';
import getIsMobile from '../OneHat/functions/getIsMobile';
import {
	cssReset,
	cssDefault,
} from '../styles/styles';

export default (props) => {
	const {
			html,
			uri,
		} = props,
		isMobile = getIsMobile(),
		source = {};


	if (!isMobile) {
		return <iframe src={uri} style={{ height: '100%', width: '100%', }} />;
	}

	if (uri) {
		source.uri = uri; // Will not respond to external links without embedded script
	} else {
		source.html = '<html>' + 
			'<head>' + 
				'<meta name="viewport" content="width=device-width, initial-scale=1.0">' + 
				`<link href="https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,400;0,900;1,400&display=swap" rel="stylesheet">` +
				`<style type="text/css">${cssReset}</style>` + 
				`<style type="text/css">${cssDefault}</style>` + 
			'</head>' + 
			'<body>' + 
				html + 

				// Inject JS to hijack all external links
				'<script>' + 
				`document.addEventListener('click', (e) => {
					e.preventDefault();
					const target = e.target,
						href = target && target.href;
					if (href) {
						const msg = JSON.stringify({ action: 'navigate', href })
						window.ReactNativeWebView.postMessage(msg); // arg1 must be a string
					}
				});` +
				'</script>' +
			'</body>' + 
			'</html>'
	}

	return <Box style={{
				flexGrow: 1,
				width: '100%',
			}}>
				<WebView
					originWhitelist={[
						'*',
					]}
					scrollEnabled={true}
					source={source}
					startInLoadingState={true}
					incognito={AppGlobals.clearBrowserCache}
					javaScriptEnabled={true}
					onMessage={onMessage}
				/>
			</Box>;
}
